import React from "react";
import { useDCS } from "../../../Table/DCSContext";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import { docsColumns } from "./docsColumns";
import { Box } from "@mui/material";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";

export default function DocsTable({ sx }) {
  const { selectedDocuments, setSelectedDocuments } = useDCS();
  console.log("selectedDocuments", selectedDocuments);

  const onChangePurpose = (docId, newPurpose) => {
    const updated = selectedDocuments.map((doc) => {
      return doc.id === docId ? { ...doc, purpose: newPurpose } : doc;
    });

    setSelectedDocuments(updated);
  };

  const table = useMaterialReactTable({
    data: selectedDocuments,
    columns: docsColumns(onChangePurpose),
    ...lightTable,
  });
  return (
    <Box sx={sx}>
      <InputGroupShape name="Selected Documents">
        <MaterialReactTable table={table} />
      </InputGroupShape>
    </Box>
  );
}
